/* eslint-disable max-len */
/* eslint-disable react/jsx-curly-brace-presence */
import { useState, useRef } from 'react';
import { PREFILLED_SHOP_DOMAIN_KEY } from '@constants';
import { Snackbar, IconButton, Button } from '@mui/material';
import { parseDomain, ParseResultType, fromUrl } from 'parse-domain';
import request from '@api';

import CloseIcon from '@mui/icons-material/Close';
import shopifyImg from '@assets/shopify.png';
import { readClipboard } from '../../utils';

import classes from './index.module.css';

export default function ConnectStore() {
  const [enable, setEnable] = useState(false);
  const [shopName, setShopName] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });
  const inputRef = useRef();

  // useEffectOnce(() => {
  //   const prefill = async () => {
  //     const clipboardText = await readClipboard();
  //     const shopifyUrl = clipboardText.indexOf('myshopify.com') > -1 ? clipboardText : '';
  //     // parse and prefill shop domain if exist
  //     const shop = localStorage.getItem(PREFILLED_SHOP_DOMAIN_KEY) || shopifyUrl ? fromUrl(shopifyUrl) : '';
  //     if (shop) {
  //       const parseResult = parseDomain(shop);
  //       if (parseResult.type === ParseResultType.Listed) {
  //         const { subDomains, domain, topLevelDomains } = parseResult;
  //         const name = subDomains.length ? `${subDomains.join('.')}.${domain}` : domain;
  //         console.log(`ParseResult: ${JSON.stringify({ subDomains, domain, topLevelDomains })}; Prefill: ${name}`);
  //         setShopName(name);
  //         setEnable(true);
  //       }
  //       localStorage.removeItem(PREFILLED_SHOP_DOMAIN_KEY);
  //     }
  //   };
  //   prefill();
  // }, []);

  const prefillHandler = async () => {
    if (shopName) {
      return null;
    }
    const clipboardText = await readClipboard();
    const shopifyUrl = clipboardText.indexOf('myshopify.com') > -1 ? clipboardText : '';
    // parse and prefill shop domain if exist
    const shop = localStorage.getItem(PREFILLED_SHOP_DOMAIN_KEY) || shopifyUrl ? fromUrl(shopifyUrl) : '';
    if (shop) {
      const parseResult = parseDomain(shop);
      if (parseResult.type === ParseResultType.Listed) {
        const { subDomains, domain, topLevelDomains } = parseResult;
        const name = subDomains.length ? `${subDomains.join('.')}.${domain}` : domain;
        console.log(`ParseResult: ${JSON.stringify({ subDomains, domain, topLevelDomains })}; Prefill: ${name}`);
        setShopName(name);
        setEnable(true);
      }
      localStorage.removeItem(PREFILLED_SHOP_DOMAIN_KEY);
    }
    return null;
  };

  const inputHandler = () => {
    const { value } = inputRef.current;
    setShopName(value);
    if (value.length && !enable) {
      setEnable(true);
    }
    if (!value.length && enable) {
      setEnable(false);
    }
  };

  const clickHandler = async () => {
    const shopDomain = `${shopName}.myshopify.com`.toLocaleLowerCase();
    // /gateway/payment-service/api/open-platform/
    const { code, message } = await request('before-connect-store', {
      method: 'POST',
      body: { shopDomain },
    }).catch(console.log);

    if (code !== 0) {
      setSnackbar({ open: true, message });
    } else {
      const url = `https://${process.env.SHOPIFY_APP_INSALLATION_URI}/auth?shop=${shopDomain}`;
      window.location.replace(url);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.wrap}>
        <img src={shopifyImg} alt="" className={classes.image} />
        <div>
          <div className={classes.title}>
            Store URL
          </div>
          <div className={classes.text}>
            {'Please enter in your custom Shopify subdomain. If your subdomain is example.shopify.com, then enter in "example".'}
          </div>
        </div>
        <div className={classes.input_line}>
          <div className={classes.input_protocol}>
            https://
          </div>
          <input
            ref={inputRef}
            onFocus={prefillHandler}
            onChange={inputHandler}
            className={classes.input_store}
            placeholder={'your-shop-url'}
            value={shopName || ''}
          />
          <div className={classes.input_domin}>
            .myshopify.com
          </div>
        </div>
        <Button
          style={{ textTransform: 'none' }}
          disabled={!enable}
          sx={{
            width: '360PX',
            height: '36PX',
            borderRadius: '4PX',
            boxSizing: 'border-box',
            backgroundColor: '#645AFF',
            color: 'white',
            '&:hover': {
              backgroundColor: '#5950DF',
            },
            '&:disabled': {
              backgroundColor: '#C8C5FF',
              color: '#FFFFFF',
            },
          }}
          onClick={clickHandler}
        >
          Connect Shopify
        </Button>
        <div className={classes.empty} />
      </div>
      <Snackbar
        sx={{
          '& .MuiPaper-root.MuiSnackbarContent-root': {
            backgroundColor: '#D82C0D',
          },
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={!!((snackbar.open && snackbar.message))}
        autoHideDuration={20000}
        message={snackbar.message}
        onClose={() => setSnackbar({ open: false, message: '' })}
        action={(
          <IconButton
            aria-label="close"
            color="inherit"
            sx={{ p: 0.5 }}
            onClick={() => setSnackbar({ open: false, message: '' })}
          >
            <CloseIcon />
          </IconButton>
        )}
      />
    </div>
  );
}
